// Borradores de carga (20-oct-2026): lo que se está cargando sobrevive a salir de la app.
// En el celu, salir a sacar una foto puede hacer que el navegador recargue la pestaña. Por eso cada
// formulario guarda su borrador en dos lados:
//  - localStorage: versión liviana, sin las fotos recién sacadas (data URL pesadas). Se lee al
//    abrir para saber si hay algo que ofrecer ("Tenés … sin terminar").
//  - IndexedDB: el borrador completo, con fotos. Es el que se usa al tocar "Seguir".
// Si IndexedDB falla (modo privado, navegador viejo), queda la versión liviana: se pierden solo
// las fotos sin subir, no el resto.

const BASE = 'gestiondlt-borradores';
const TABLA = 'borradores';

// Clave por usuario: en un celu compartido o al cambiar de usuario no se mezclan
export function claveBorrador(nombre) {
    try {
        const u = JSON.parse(localStorage.getItem('auth_usuario') || '{}');
        return `${nombre}:${u.id || u.username || 'x'}`;
    } catch { return `${nombre}:x`; }
}

function abrir() {
    return new Promise((ok, mal) => {
        if (typeof indexedDB === 'undefined') { mal(new Error('sin IndexedDB')); return; }
        const r = indexedDB.open(BASE, 1);
        r.onupgradeneeded = () => r.result.createObjectStore(TABLA);
        r.onsuccess = () => ok(r.result);
        r.onerror = () => mal(r.error);
    });
}

async function operar(modo, fn) {
    const db = await abrir();
    try {
        return await new Promise((ok, mal) => {
            const tx = db.transaction(TABLA, modo);
            const req = fn(tx.objectStore(TABLA));
            tx.oncomplete = () => ok(req?.result);
            tx.onerror = () => mal(tx.error);
        });
    } finally { db.close(); }
}

// Saca las fotos sin subir (data URL) para la versión liviana
const sinFotosNuevas = (v) => JSON.parse(JSON.stringify(v, (k, x) => (typeof x === 'string' && x.startsWith('data:') ? null : x)));

export function guardarBorrador(clave, valor) {
    try { localStorage.setItem(clave, JSON.stringify(sinFotosNuevas(valor))); } catch { /* lleno: queda IndexedDB */ }
    operar('readwrite', s => s.put(valor, clave)).catch(() => { /* queda la versión liviana */ });
}

// Versión liviana, sincrónica: para decidir si mostrar el aviso
export function hayBorrador(clave) {
    try { return JSON.parse(localStorage.getItem(clave) || 'null'); } catch { return null; }
}

// Borrador completo (con fotos); si no está en IndexedDB, la versión liviana
export async function leerBorrador(clave) {
    try {
        const completo = await operar('readonly', s => s.get(clave));
        if (completo) return completo;
    } catch { /* sin IndexedDB */ }
    return hayBorrador(clave);
}

export function borrarBorrador(clave) {
    try { localStorage.removeItem(clave); } catch { /* */ }
    operar('readwrite', s => s.delete(clave)).catch(() => { /* */ });
}
